import { getSiteUrl } from './site-url';

/** Full wordmark — hero, primary brand moments. */
export const BRAND_LOGO_TRANSPARENT_PATH = '/YesWeCanLogo_Transparent.png';

/** Logomark — footer, favicon, JSON-LD `logo`, Open Graph / Twitter default image. */
export const BRAND_LOGOMARK_TRANSPARENT_PATH = '/YesWeCanLogomark_Transparent.png';

export function brandLogoAbsoluteUrl(): string {
  return `${getSiteUrl()}${BRAND_LOGO_TRANSPARENT_PATH}`;
}

export function brandLogomarkAbsoluteUrl(): string {
  return `${getSiteUrl()}${BRAND_LOGOMARK_TRANSPARENT_PATH}`;
}
